module.exports = __webpack_public_path__ + "static/media/warning-triangle.ec50b083.svg";